import { useState } from "react"
import { Grid } from "@mui/material"

export function CollapseItem({ children, ...props }) {
    const [show, setShow] = useState(false)
    return children ? (
        <Grid ref={attach} item {...props} sx={{ ...props.sx, display: show ? "block" : "none" }}>
            {children}
        </Grid>
    ) : null

    function attach(container) {
        if (container) {
            if (container.innerHTML) {
                setShow(true)
            }
        }
    }
}
